import "./GarbageCard.css";
import {Trash, XLg} from "react-bootstrap-icons";
import {Garbage} from "../../Views/GarbageView/GarbageView";
import React from "react";
import moment from "moment";

interface Props {
    garbage: Garbage;
    daysLeft: number | null;
    deleteGarbage(id:number): void;
}

export const GarbageCard = ({garbage, daysLeft, deleteGarbage}: Props) => {

    return (
        <div
            className={`col-3 col-lg-1 m-2 p-0 border-custom position-relative ${garbage.isLoading?'opacity-50 border-danger':''} garbage-${garbage.garbageType}`}
            style={{minHeight: "90px"}}>
            {garbage.isLoading ?
                <div className="garbage-loader_wrapper position-absolute top-50 start-50 translate-middle pointer-loading">
                    <svg className="loader" width="30" height="30" viewBox="0 0 44 44">
                        <circle cx="22" cy="22" r="20" fill="none" strokeWidth="4"></circle>
                    </svg>
                </div>
                : null}
            <div className="position-absolute top-0 end-0">
                    <XLg onClick={() => deleteGarbage(garbage.id)} className="delete-icon pointer"/>
            </div>

            <div className="position-absolute top-50 start-50 translate-middle no-pointer">
                <div className={`garbage-days-left garbage-days-left--${garbage.garbageType}`}>{daysLeft?? <Trash className={"garbage-trash"}/>}</div>
            </div>

            <div className="position-absolute bottom-0 start-50 translate-middle-x no-pointer">
                <div className={"description d-flex justify-content-center"}>{moment(garbage.garbageDate).format('DD.MM.YYYY').toString()}</div>
            </div>
        </div>
    );
};
